document.addEventListener('DOMContentLoaded', () => {
  AOS.init();
});
